/* eslint-disable */
import React from "react";
import PageSkeleton from "./PageSkeleton";

// Loader now shows a content-shaped skeleton (like the dashboard) instead of
// a spinning circle.
function Loader() {
  return <PageSkeleton />;
}

export default Loader;
